import { hasWorkoutsDayUtil } from 'modules/day/utils/hasWorkouts/index.js'

export const isRestDayUtil = day => {
  return !hasWorkoutsDayUtil(day)
}
